import React from 'react';
import PropTypes from 'prop-types';
import { HighlyRatedCard } from 'site-modules/used-cars-landing/components/highly-rated-card/highly-rated-card';
import './highly-rated-module.scss';

function parseMetadata(metadata, length) {
  const parsedMetadata = [];
  for (let i = 1; i <= length; i += 1) {
    if (metadata[`link-url-${i}`] && metadata[`media-image-${i}`] && metadata[`title-${i}`]) {
      parsedMetadata.push({
        'link-url': metadata[`link-url-${i}`],
        'media-image': metadata[`media-image-${i}`],
        title: metadata[`title-${i}`],
      });
    }
  }
  return parsedMetadata;
}

export function HighlyRatedModule({ highlyRatedContent, className = '' }) {
  const highlyRated = parseMetadata(highlyRatedContent.getAllMetadata(), 6);
  const title = highlyRatedContent.title;

  return (
    <div className={className}>
      <div className="row highly-rated pe-1_5 text-gray-darker">
        <h2 className="heading-3 pb-0_5 col-12">{title}</h2>
        {highlyRated.map(link => (
          <HighlyRatedCard vehicles={link} key={link['link-url']} />
        ))}
      </div>
    </div>
  );
}

HighlyRatedModule.propTypes = {
  highlyRatedContent: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
};
